import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["name", "noStyleOverride"];
import app from '../app';
import classList from '../utils/classList';
import applyIconStyle from '../utils/applyIconStyle';
import Component from '../Component';
export default class Icon extends Component {
  view(vnode) {
    var _app$forum;
    const _vnode$attrs = vnode.attrs,
      {
        name,
        noStyleOverride
      } = _vnode$attrs,
      attrs = _objectWithoutProperties(_vnode$attrs, _excluded);

    // Admins can force every icon to a particular FontAwesome style
    // (e.g. `fa-duotone fa-light`); empty means icons render as declared.
    const forcedStyle = noStyleOverride ? null : app == null || (_app$forum = app.forum) == null ? void 0 : _app$forum.attribute('fontAwesomeForcedStyle');

    // @ts-ignore
    attrs.className = classList('icon', forcedStyle ? applyIconStyle(name, forcedStyle) : name, attrs.className);
    return m("i", Object.assign({
      "aria-hidden": "true"
    }, attrs));
  }
}
flarum.reg.add('core', 'common/components/Icon', Icon);